import print from 'print-js';

import { initGrid } from 'utils/grid/grid';

import { downloadManageInventoryReportByTab } from 'manage-inventory/actions/download-report-by-tab.actions';
import template from './inventory-games-tab.html';

import { fetchGamesList } from '../../actions/fetch-games-list.actions';

const mapStateToThis = ({ manageInventory, config, ui, dictionary, session }) => {
  const { games, isLoading } = manageInventory;
  const { defaultPageSizes, sortColumnKey, pageSizeKey, usesPortionedPacks } = config;
  const { pagination, activeTab } = ui;
  const { locale } = session;
  const terms = dictionary.terms[locale];

  return {
    games,
    terms,
    isLoading,
    activeTab,
    pagination,
    pageSizeKey,
    sortColumnKey,
    defaultPageSizes,
    usesPortionedPacks,
  };
};

const mapDispatchToThis = {
  fetchGamesList,
  downloadManageInventoryReportByTab,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$stateParams', 'gettextCatalog')
class InventoryGamesTabController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
    this.print = print;
  }

  $onInit() {
    this.actions = this.getActions();
    this.headers = this.getHeaders();
    this.defaultParams = {
      [this.pageSizeKey]: this.defaultPageSizes[2],
      [this.sortColumnKey]: 'gameName',
      retailerId: this.$stateParams.retailerNo,
    };
    this.gridModel = initGrid(this.fetchGamesList, this.defaultParams);
    this.preserveFilters();
    this.search();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  search() {
    if (this.gamesFilters && this.gamesFilters.$invalid) return;

    this.gridModel.applyFilters().then(() => {
      this.preserveFilters();
    });
  }

  clear() {
    this.gridModel.pagingModel.filters = { gameNumber: '' };
    this.search();
  }

  preserveFilters() {
    this.preservedFilters = { ...this.gridModel.pagingModel.filters };
  }

  getActions() {
    return [
      {
        type: 'download',
        function: this.onDownloadReport.bind(this),
        extension: 'xlsx',
      },
      {
        type: 'print',
        function: this.handlePrint.bind(this),
      },
    ];
  }

  getHeaders() {
    return [
      {
        text: this.gettextCatalog.getString('Game No.'),
        field: 'gameNumber',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Game Name'),
        field: 'gameName',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Price Point'),
        field: 'pieceValue',
        sortable: true,
        textAlignment: 'text-right',
      },
      {
        /// {{ pack }} is Lottery term using to determine Pack.
        text: this.gettextCatalog.getString('{{ pack }} Value', {
          pack: this.terms.PACK.singular,
        }),
        field: 'packValue',
        sortable: true,
        textAlignment: 'text-right',
      },
      {
        /// {{ pack }} is Lottery term using to determine Pack, {{ issued }} is Lottery term using to determine Pack status.
        text: this.usesPortionedPacks
          ? this.gettextCatalog.getString('{{ pack }}/{{ portion }} {{ issued }}', {
              pack: this.terms.PACK.plural,
              portion: this.terms.PORTION.plural,
              issued: this.terms.ISSUED.singular,
            })
          : this.gettextCatalog.getString('{{ pack }} {{ issued }}', {
              pack: this.terms.PACK.plural,
              issued: this.terms.ISSUED.singular,
            }),
        field: 'issuedCnt',
        sortable: true,
        textAlignment: 'text-right',
      },
      {
        /// {{ pack }} is Lottery term using to determine Pack, {{ confirmed }} is Lottery term using to determine Pack status.
        text: this.usesPortionedPacks
          ? this.gettextCatalog.getString('{{ pack }}/{{ portion }} {{ confirmed }}', {
              pack: this.terms.PACK.plural,
              portion: this.terms.PORTION.plural,
              confirmed: this.terms.CONFIRMED.singular,
            })
          : this.gettextCatalog.getString('{{ pack }} {{ confirmed}}', {
              pack: this.terms.PACK.plural,
              confirmed: this.terms.CONFIRMED.singular,
            }),
        field: 'confirmedCnt',
        sortable: true,
        textAlignment: 'text-right',
      },
      {
        /// {{ pack }} is Lottery term using to determine Pack.
        text: this.usesPortionedPacks
          ? this.gettextCatalog.getString('{{ pack }}/{{ portion }} on Display', {
              pack: this.terms.PACK.plural,
              portion: this.terms.PORTION.plural,
            })
          : this.gettextCatalog.getString('{{ pack }} on Display', {
              pack: this.terms.PACK.plural,
            }),
        field: 'onDisplayCnt',
        sortable: true,
        textAlignment: 'text-right',
      },
    ];
  }

  onDownloadReport() {
    const pagingModel = {
      ...this.gridModel.pagingModel,
      filters: this.preservedFilters,
      pageSize: 0, // BE contract - pageSize = 0 triggers exporting entire data set
    };

    const requestParams = {
      ...pagingModel,
      tabId: this.activeTab,
      retailerId: this.$stateParams.retailerNo,
    };

    return this.downloadManageInventoryReportByTab(requestParams);
  }

  handlePrint() {
    this.print({
      printable: 'inventory-games-tab',
      type: 'html',
    });
  }
}

export default class InventoryGamesTabComponent {
  constructor() {
    this.controller = InventoryGamesTabController;
    this.template = template;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/components/inventory-games-tab/inventory-games-tab-component.js